var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.21 8H7V17C7 17.55 7.45 18 8 18C8.55 18 9 17.55 9 17V8H10.79C11.24 8 11.46 7.46 11.14 7.15L8.35 4.36C8.15 4.16 7.84 4.16 7.64 4.36L4.85 7.15C4.54 7.46 4.76 8 5.21 8ZM0 1C0 1.55 0.45 2 1 2H15C15.55 2 16 1.55 16 1C16 0.45 15.55 0 15 0H1C0.45 0 0 0.45 0 1Z","fill":"#334155"}));
}

Icon.defaultProps = {"width":"16","height":"18","viewBox":"0 0 16 18","fill":"none"};

module.exports = Icon;

Icon.default = Icon;
